.grid {
  max-width: 1440px;
  padding: 6px 0;
  width: 100%;
}

.offersTab {
  margin: 16px auto;
  max-width: 1440px;
}

.sportsLandingPage,
.card {
  margin: 16px auto;
  padding: 0 22px;
  width: 100%;
  max-width: 1440px;
}

/* 1440px + 16px */
@media (max-width: 1472px) {
  .sportsLandingPage,
  .card {
    overflow-x: hidden;
  }
}
